import React from 'react';
import CoursePackage from '@/components/CoursePackage';
import { useTranslation } from 'next-i18next';

const CoursePackageBlock = () => {
  const { t } = useTranslation(['home', 'path', 'math']);

  const config = [
    {
      packageName: t('math:课程包-课时-1-课包名'),
      hoursClass: t('math:课程包-课时-1-课时'),
      price: t('math:课程包-课时-1-价格'),
      btnName: t('math:课程包-按钮'),
      description: t('math:课程包-课时-1-描述'),
      id: '1',
      ga: 'BasicCourseCTAClick',
    },
    {
      packageName: t('math:课程包-课时-2-课包名'),
      hoursClass: t('math:课程包-课时-2-课时'),
      price: t('math:课程包-课时-2-价格'),
      btnName: t('math:课程包-按钮'),
      description: t('math:课程包-课时-2-描述'),
      label: '课程包-标签1',
      id: '2',
      ga: 'RegularCourseCTAClick',
    },
    {
      packageName: t('math:课程包-课时-3-课包名'),
      hoursClass: t('math:课程包-课时-3-课时'),
      price: t('math:课程包-课时-3-价格'),
      btnName: t('math:课程包-按钮'),
      description: t('math:课程包-课时-3-描述'),
      label: '课程包-标签2',
      id: '3',
      ga: 'ValuePackCTAClick',
    },
  ];

  return (
    <section className="marginModelTop">
      <CoursePackage
        subject="math"
        config={config}
        blockSubTitle={t('math:课程包-副标题')}
        blockTitle={t('math:课程包-标题')}
        useTranslationName="math"
      />
    </section>
  );
};

export default CoursePackageBlock;
